import { GetProxy, TeamProxyRelations } from '../../../../api/Proxy/schema';
import { IntlShape } from 'react-intl';
import { ErrorCode, localizeErrorCode } from '../../../../Types/ErrorCode';
import { ProxyStep } from './StepEnum';
import { ReportingTeamUser, TeamProfile } from '../../../../Types';

export const getUsersBeingProxied = (teamProxy: GetProxy): string[] => {
  const proxyRelations = teamProxy?.getTeamProxyV2?.proxyRelations || [];
  return proxyRelations.flatMap(relation => relation.proxyCoachees);
};

export const getModalTitle = (
  intl: IntlShape,
  isOM: boolean,
  step: ProxyStep,
  selfProxyStep: boolean = false
): string => {
  if (selfProxyStep) {
    return intl.formatMessage({
      id: 'cs_perfportal_assign_new_proxy_for_myself',
      defaultMessage: 'Assign a new proxy for myself',
    });
  }

  if (isOM) {
    return step === ProxyStep.RELATIONSHIPS
      ? intl.formatMessage({
          id: 'cs_perfportal_manage_proxies_modal',
          defaultMessage: 'Manage proxies',
        })
      : intl.formatMessage({
          id: 'cs_perfportal_assign_proxy_modal_for_someone_you_manage',
          defaultMessage: 'Assign a new proxy for someone you manage',
        });
  }

  return intl.formatMessage({
    id: 'cs_perfportal_manage_proxies_modal',
    defaultMessage: 'Manage proxies',
  });
};

export const localizeErrorMessage = (
  intl: IntlShape,
  messageCode: string,
  alias: string
): string => {
  return intl.formatMessage(localizeErrorCode(messageCode as ErrorCode), {
    alias: alias ?? '',
  });
};

interface ProxyRelationshipData {
  proxyUserData: ReportingTeamUser;
  originalUserData: ReportingTeamUser;
  uniqueId: string;
}

export const findProxyRelationshipData = (
  relation: TeamProxyRelations,
  coacheeId: string,
  teamProfile: TeamProfile,
  cscEntityPrefix: string
): ProxyRelationshipData | null => {
  const proxyUserData = teamProfile?.reportingTeam.find(tm => {
    const constructedId = `${cscEntityPrefix}:${tm.relatedUser.userID}`;
    return constructedId === relation.userID;
  });

  const originalUserData = teamProfile?.reportingTeam.find(tm => {
    const constructedId = `${cscEntityPrefix}:${tm.relatedUser.userID}`;
    return constructedId === coacheeId;
  });

  if (!proxyUserData || !originalUserData || !originalUserData.isManager) {
    return null;
  }

  const uniqueId = `${proxyUserData.relatedUser.userID}-${originalUserData.relatedUser.userID}`;

  return {
    proxyUserData,
    originalUserData,
    uniqueId,
  };
};
